import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react';

interface AppErrorBoundaryState {
  hasError: boolean;
}

export class AppErrorBoundary extends Component<PropsWithChildren, AppErrorBoundaryState> {
  state: AppErrorBoundaryState = {
    hasError: false
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('FlatRate Pro: uncaught error in React tree.', error, errorInfo);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="frp-error-shell">
          <div className="frp-error-card" role="alert" aria-live="assertive">
            <p className="frp-eyebrow">FlatRate Pro</p>
            <h1 style={{ fontSize: 'var(--text-xl)', fontWeight: 700, fontFamily: 'var(--font-display)' }}>
              Something went wrong.
            </h1>
            <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
              Reload the app to try again.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)', marginTop: 'var(--space-2)' }}>
              <button
                type="button"
                className="frp-btn frp-btn-primary frp-btn-full"
                onClick={() => window.location.reload()}
              >
                Reload FlatRate Pro
              </button>
              <button
                type="button"
                className="frp-btn frp-btn-secondary frp-btn-full"
                onClick={() => window.location.assign(import.meta.env.BASE_URL || '/frp/')}
              >
                Return to home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
